import { render, staticRenderFns } from "./PdfViewerModal.vue?vue&type=template&id=3fc2b5dc&scoped=true"
import script from "./PdfViewerModal.vue?vue&type=script&lang=js"
export * from "./PdfViewerModal.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerModal.vue?vue&type=style&index=0&id=3fc2b5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2b5dc",
  null
  
)

export default component.exports